import React from "react";
import "../Arrays/ArrayBundle.css";
import "./SearchingBundle.css";
import { Link } from "react-router-dom";

class SearchingBundle extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0);
		document.title = "Searching Bundle | CSCult's Gamified CP";
	}

	render() {
		return (
			<main style={{ margin: "1rem 12rem" }}>
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
				<div className="bundle-intro-container">
					<h1>Introduction to Searching</h1>
					<p>
						Imagine you have 100 pairs of socks. Really?{" "}
						<b>A 100 pairs of socks!</b> Let's say you have them. A
						Batman-version pair of socks, a Yoda-themed pair of
						socks or just a cliched white pair of socks...
					</p>
					<p>
						Now you are off to a Star Wars themed costume party. I
						mean you could wear a Yoda outfit, but it's really,
						really cold out there. And it's winter. So...
					</p>
					<img id="yoda-gif" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fexpresswriters.com%2Fwp-content%2Fuploads%2F2017%2F11%2Fyoda.gif&f=1&nofb=1" />
					<span>Much to learn, you still have</span>
					<p>
						You choose to put on your Yoda-themed pair of socks. Now
						you are apparently a very clumsy person. You don't have
						your socks collection assorted prehand. And it's a 100
						pair of socks collection in a long drawer, stacked
						side-to-side.
					</p>
					<p>
						Now you are lucky if you have the Yoda pair at the
						beginning of the drawer. So you could just pick it up.
						But imagine if the Yoda pair is at the end and obviously
						you don't know that!
					</p>
					<p>
						Say it takes 2 seconds to check one pair of socks, and
						you have 100 pairs; so in the worst-case scenario, it
						takes you <code>200 seconds</code>, i.e. almost three and a half
						minutes to find the socks (time-consuming).
					</p>
						<img id="socks-gif" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fksr-ugc.imgix.net%2Fassets%2F022%2F751%2F164%2F3e19eae5c0894937c35b2eeeafd28fe5_original.gif%3Fixlib%3Drb-2.1.0%26w%3D680%26fit%3Dmax%26v%3D1538485323%26auto%3Dformat%26gif-q%3D50%26q%3D92%26s%3Deeb579ca07dc5d958e0756e82b677504&f=1&nofb=1" />
						<span>Mix & Mismatch</span>
						<p>
							Now if you knew about <b>Searching algorithms</b>, you would be able to find the desired pair of socks quickly and efficiently.
						</p>
						<p>
							To learn about the searching algorithms, check out the subbundles below:
						</p>
				</div>
				<h1
					style={{
						marginLeft: "4rem",
						marginBottom: "3rem",
						color: "white",
						fontFamily: "Poppins",
						fontWeight: "700",
						fontSize: "4rem",
					}}
				>
					More on searching...
				</h1>
				<div className="bundle-games">
					<div className="bundle-game">
						<Link
							style={{ WebkitTextStroke: "1px black" }}
							to="./searching/linear"
							id="linear-search-div"
						>
							Linear Search
						</Link>
						<p>
							Linear search is a powerful tool if you have less items, a little over 100. So in the sock example, will linear search help you find the Yoda-themed socks? Head on over to the <b>Linear Search</b> Bundle Game to learn more.
						</p>
					</div>
					<div className="bundle-game">
						<p>
							Have you considered what happens when our computer
							either manipulates an array by adding or removing
							elements or retrieves elements from an array? You
							can understand it by going through the{" "}
							<b>Addressing</b> Bundle Game.
						</p>
						<Link
							to="./searching/binary"
							id="binary-search-div"
						>
							Binary Search
						</Link>
					</div>
				</div>
			</main>
		);
	}
}

export default SearchingBundle;
